import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../common/Card';
import { formatCategory, formatDateShort, truncateText } from '../../utils/formatters';

const BlogCard = ({ post }) => {
  return (
    <Link to={`/blog/${post.slug}`}>
      <Card hover>
        {post.coverImage && (
          <div className="relative overflow-hidden aspect-w-16 aspect-h-10">
            <img
              src={post.coverImage}
              alt={post.title}
              className="w-full h-64 object-cover transition-transform duration-600 hover:scale-105"
              loading="lazy"
            />
          </div>
        )}

        <div className="p-6 lg:p-8">
          <div className="flex items-center justify-between mb-3">
            {post.category && (
              <span className="text-sm text-accent font-body font-semibold uppercase tracking-wider">
                {formatCategory(post.category)}
              </span>
            )}
            {post.publishedDate && (
              <span className="text-sm text-text-light font-body">
                {formatDateShort(post.publishedDate)}
              </span>
            )}
          </div>

          <h3 className="text-xl lg:text-2xl font-heading font-bold text-secondary mb-3 leading-tight group-hover:text-accent transition-colors duration-400">
            {post.title}
          </h3>

          <p className="text-text-secondary font-body leading-relaxed line-clamp-3 mb-4">
            {post.excerpt || truncateText(post.content, 150)}
          </p>

          {post.tags && post.tags.length > 0 && (
            <div className="mt-4 flex flex-wrap gap-2">
              {post.tags.slice(0, 3).map((tag, index) => (
                <span
                  key={index}
                  className="text-xs bg-accent-light text-secondary px-3 py-1 rounded-full font-body"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}

          <div className="mt-6 text-accent font-body font-semibold flex items-center group">
            <span className="group-hover:mr-2 transition-all duration-300">Read more</span>
            <span className="opacity-0 group-hover:opacity-100 transition-all duration-300">→</span>
          </div>
        </div>
      </Card>
    </Link>
  );
};

export default BlogCard;
